var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 2h7v7H8.5V4.56L2.56 10.5 1.5 9.44 7.44 3.5H3z"
})));
export default SvgArrowUpRight;